export default "__VITE_ASSET__BVgMjKNj__"